/* Kowloon campaign adapter. No DOM clone, visit storage, scroll interception or network writes. */
(async()=>{
  'use strict';
  const configNode=document.getElementById('KobColourArrivalConfig');
  if(!window.ResizeObserver)return;
  if(!configNode||window.KobColourArrival)return;
  let config;try{config=JSON.parse(configNode.textContent);}catch{return;}
  const managed=config.mode==='managed';
  let policy=managed?await window.KobStorefrontColourPolicy?.ready:null;
  let policyKey='',paletteStyles=new Map();
  const preview=new URLSearchParams(location.search).get('kob_colour_preview')==='1';
  const inspection=config.study===true&&['127.0.0.1','localhost'].includes(location.hostname)&&new URLSearchParams(location.search).get('kob_inspect')==='1';
  if(!managed&&config.mode!=='live'&&!(config.mode==='preview'&&(preview||window.Shopify?.designMode)))return;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const root=document.documentElement;
  const ignore='button,a,input,select,textarea,details,dialog,cart-drawer,.menu-drawer,.drawer,.search-modal,.cart-notification,.media,.banner__media,[data-kob-colour-ignore]';
  const selector='body,.header-wrapper,.utility-bar,#MainContent .gradient,#MainContent .kob-release-entry,.footer';
  const records=new Map();let driver=null,wave=null,logo=null,raf=0,timeout=0,observer=null;
  let colours=[],logoWidth=0,renderFrame=null,lastFrame=0;
  let running=false,settled=false,width=0,height=0,start=0,total=8400,origin=null,dirty=true;
  const rgba=s=>(s.match(/[\d.]+/g)||[]).map(Number);
  const colourProps=['color','background-color','border-top-color','border-right-color','border-bottom-color','border-left-color','text-decoration-color','fill','stroke'];
  const parseColour=value=>/^rgba?\(/.test(value)?[...rgba(value).slice(0,3),rgba(value)[3]??1]:null;
  const blend=(a,b,p)=>'rgba('+a.map((v,i)=>+(v+(b[i]-v)*p).toFixed(i===3?3:1)).join(',')+')';
  function saveStyle(el,prop){return [el.style.getPropertyValue(prop),el.style.getPropertyPriority(prop)];}
  function restoreStyle(el,prop,saved){if(saved[0])el.style.setProperty(prop,...saved);else el.style.removeProperty(prop);}
  function clearColours(){
    colours.forEach(rec=>rec.saved.forEach((value,prop)=>restoreStyle(rec.el,prop,value)));
    colours=[];
  }
  function prepareColours(){
    // Two batched style reads, before/after the palette. Never copy live controls or text.
    const nodes=[...document.body.querySelectorAll('*'),document.body].filter(el=>
      el.closest('[data-kob-colour-surface]')&&!el.closest('.kob-colour-logo,.kob-colour-paint,cart-drawer,.menu-drawer,.drawer,.search-modal,.cart-notification,[data-kob-colour-ignore]')&&
      !el.matches('script,style,link,img,video,source,canvas')&&el.getClientRects().length);
    const before=nodes.map(el=>{
      const s=getComputedStyle(el),values=Object.fromEntries([...colourProps,'background-image'].map(p=>[p,s.getPropertyValue(p)]));
      values.properties=colourProps.filter(prop=>{
        if(prop==='color')return el.matches('button,input,select,textarea,.button')||[...el.childNodes].some(n=>n.nodeType===3&&n.textContent.trim());
        if(prop==='fill'||prop==='stroke')return el.namespaceURI==='http://www.w3.org/2000/svg';
        if(prop==='text-decoration-color')return s.textDecorationLine!=='none';
        if(prop.startsWith('border-'))return parseFloat(s.getPropertyValue(prop.replace('color','width')))>0&&s.getPropertyValue(prop.replace('color','style'))!=='none';
        return true;
      });return values;
    });
    records.forEach(rec=>{rec.el.dataset.kobColourArrived='';rec.el.dataset.kobColourSettled='';});
    root.dataset.kobColourActive='';
    const after=nodes.map(el=>{const s=getComputedStyle(el);return Object.fromEntries(colourProps.map(p=>[p,s.getPropertyValue(p)]));});
    records.forEach(rec=>delete rec.el.dataset.kobColourSettled);
    nodes.forEach((el,i)=>{
      const tracks=before[i].properties.flatMap(prop=>{
        if(prop==='background-color'&&records.has(el))return [];
        const a=parseColour(before[i][prop]),b=parseColour(after[i][prop]);
        return a&&b&&before[i][prop]!==after[i][prop]?[{prop,a,b,from:before[i][prop],to:after[i][prop]}]:[];
      });
      if(!tracks.length)return;
      const saved=new Map(tracks.map(t=>[t.prop,saveStyle(el,t.prop)]));
      const text=tracks.find(t=>t.prop==='color');
      const glyph=!!text&&el.namespaceURI==='http://www.w3.org/1999/xhtml'&&
        !el.matches('button,input,select,textarea,.button')&&[...el.children].every(c=>c.tagName==='BR')&&
        el.textContent.trim()&&before[i]['background-image']==='none'&&parseColour(before[i]['background-color'])?.[3]===0;
      if(glyph)['background-image','background-clip','-webkit-background-clip','-webkit-text-fill-color'].forEach(p=>saved.set(p,saveStyle(el,p)));
      const button=el.matches('.button');
      if(button)['--color-button','--color-button-text'].forEach(p=>saved.set(p,saveStyle(el,p)));
      const rec={el,tracks,saved,glyph,text,button,rect:null,range:null,progress:0,wetAt:null};colours.push(rec);
      tracks.forEach(t=>{
        el.style.setProperty(t.prop,t.from,'important');
        if(button&&(t.prop==='color'||t.prop==='background-color'))el.style.setProperty(t.prop==='color'?'--color-button-text':'--color-button',t.a.slice(0,3).join(','));
      });
    });
    dirty=true;
  }
  function drawColours(radius,elapsed){
    if(radius<=0)return;
    colours.forEach(rec=>{
      if(rec.progress===1||!rec.el.isConnected)return;
      const {x,y,w,h}=rec.rect;
      if(!rec.range)rec.range={
        near:Math.hypot(Math.max(x-origin.x,0,origin.x-x-w),Math.max(y-origin.y,0,origin.y-y-h)),
        far:Math.max(...[[x,y],[x+w,y],[x,y+h],[x+w,y+h]].map(([a,b])=>Math.hypot(a-origin.x,b-origin.y)))
      };
      const {near,far}=rec.range;
      const feather=Math.max(65,Math.min(180,radius*.055));
      let raw=Math.max(0,Math.min(1,(radius-near+feather)/(far-near+feather*2)));
      if(raw>0&&rec.wetAt===null)rec.wetAt=elapsed;
      // Let pigment soak into a local element after the front arrives, even far down a long page.
      if(rec.wetAt!==null)raw=Math.min(raw,(elapsed-rec.wetAt)/(rec.glyph?750:500));
      const localRadius=near-feather+raw*(far-near+feather*2);
      const p=raw*raw*(3-2*raw);
      if(p===rec.progress)return;rec.progress=p;
      rec.tracks.forEach(t=>{
        if(rec.glyph&&t===rec.text&&p>0&&p<1){
          rec.el.style.setProperty('color','transparent','important');
          rec.el.style.setProperty('-webkit-text-fill-color','transparent','important');
          rec.el.style.setProperty('background-clip','text','important');
          rec.el.style.setProperty('-webkit-background-clip','text','important');
          rec.el.style.setProperty('background-image','radial-gradient(circle at '+(origin.x-x)+'px '+(origin.y-y)+'px, '+t.to+' '+Math.max(0,localRadius-feather)+'px, '+t.from+' '+(localRadius+feather)+'px)','important');
        }else{
          if(rec.glyph&&t===rec.text&&p===1)['background-image','background-clip','-webkit-background-clip','-webkit-text-fill-color'].forEach(prop=>restoreStyle(rec.el,prop,rec.saved.get(prop)));
          rec.el.style.setProperty(t.prop,p===1?t.to:blend(t.a,t.b,p),'important');
        }
        // Native button pseudo-elements use these variables for their border/fill.
        if(rec.button&&(t.prop==='color'||t.prop==='background-color'))rec.el.style.setProperty(t.prop==='color'?'--color-button-text':'--color-button',t.a.slice(0,3).map((v,i)=>+(v+(t.b[i]-v)*p).toFixed(1)).join(','));
      });
    });
  }
  const logoSizeObserver=new ResizeObserver(entries=>entries.forEach(({target})=>{logoWidth=target.getBoundingClientRect().width;target.style.setProperty('--kob-logo-width',logoWidth+'px');}));

  function discover(){
    document.querySelectorAll(selector).forEach(el=>{
      if(records.has(el)||el.closest(ignore))return;
      const style=getComputedStyle(el),colour=rgba(style.backgroundColor);
      if(el!==document.body&&(!colour.length||(colour[3]??1)<.95))return;
      // Leave photographic/complex gradient backgrounds untouched.
      if(style.backgroundImage!=='none'&&!/^linear-gradient\(rgb\([^)]+\), rgb\([^)]+\)\)$/.test(style.backgroundImage))return;
      const dark=(colour[0]*.2126+colour[1]*.7152+colour[2]*.0722)<130;
      el.dataset.kobColourSurface='';el.dataset.kobColourTone=dark?'dark':'light';
      if(managed&&policy?.banner_material==='blue-carbon'&&dark&&(el.closest('#MainContent')||el.matches('.header-wrapper')))el.dataset.kobColourMaterial='blue-carbon';
      if(style.position==='static')el.dataset.kobColourPosition='';
      const rec={el,paint:null,rect:null,done:false};records.set(el,rec);
      if(settled){settle(rec);return;}
      const paint=document.createElement('span');paint.className='kob-colour-paint';paint.setAttribute('aria-hidden','true');
      paint.style.maskSize='0px 0px';paint.style.webkitMaskSize='0px 0px';
      el.append(paint);rec.paint=paint;
    });dirty=true;
  }
  function settle(rec){rec.el.dataset.kobColourArrived='';rec.el.dataset.kobColourSettled='';rec.paint?.remove();rec.paint=null;rec.done=true;}
  function measure(){
    height=Math.max(document.body.scrollHeight,document.documentElement.scrollHeight);
    if(wave)wave.style.height=height+'px';
    records.forEach(rec=>{
      // A sticky header carries its own paint with it; its palette does not wait for a distant page row.
      if(rec.rect&&rec.el.matches('.header-wrapper,.utility-bar'))return;
      const r=rec.el.getBoundingClientRect();rec.rect={x:r.left+scrollX,y:r.top+scrollY,w:r.width,h:r.height};
    });
    colours.forEach(rec=>{
      if(rec.rect&&rec.el.closest('.header-wrapper,.utility-bar'))return;
      const r=rec.el.getBoundingClientRect();rec.rect={x:r.left+scrollX,y:r.top+scrollY,w:r.width,h:r.height};rec.range=null;
    });dirty=false;
  }
  function prepareLogo(){
    const image=document.querySelector('.header__heading-logo');
    if(!image||!image.complete||!image.naturalWidth)return null;
    // The accepted colour regions are tied to this official silhouette, not arbitrary future logos.
    if(!String(config.logo).includes('PNG-Transparent_0e9c9740-d60c-43ec-87c1-4cd53adcf8c1'))return null;
    const wrap=image.parentElement;wrap.classList.add('kob-colour-logo');
    logoWidth=wrap.getBoundingClientRect().width;wrap.style.setProperty('--kob-logo-width',logoWidth+'px');logoSizeObserver.observe(wrap);
    wrap.style.setProperty('--kob-logo-mask','url('+JSON.stringify(new URL(config.logo,location.href).href)+')');
    const pigment=document.createElement('span');pigment.className='kob-colour-logo-pigment';pigment.setAttribute('aria-hidden','true');
    const art=document.createElement('span');art.className='kob-colour-logo-art';pigment.append(art);wrap.append(pigment);return wrap;
  }
  function finish(){
    cancelAnimationFrame(raf);clearTimeout(timeout);driver?.destroy();driver=null;wave?.remove();wave=null;
    running=false;settled=true;records.forEach(settle);clearColours();logo?.classList.add('kob-colour-logo-ready');
    root.dataset.kobColourState='complete';
  }
  function begin(){
    if(running||settled||document.hidden)return;
    if(managed&&(!policy||policy.stage==='off'))return;
    discover();logo=prepareLogo();
    if(managed&&policy.stage==='hold'){root.dataset.kobColourActive='';finish();return;}
    if(reduced.matches||!logo||!window.KobColourInk||!CSS.supports('mask-image','linear-gradient(black,white)')){root.dataset.kobColourActive='';finish();return;}
    prepareColours();
    wave=document.createElement('div');wave.className='kob-colour-wave';wave.setAttribute('aria-hidden','true');wave.inert=true;document.body.append(wave);
    measure();width=document.documentElement.clientWidth;
    const box=logo.getBoundingClientRect();origin={x:box.left+scrollX+box.width*.195333,y:box.top+scrollY+box.height*.504762};
    const reach=Math.max(...[[0,0],[width,0],[0,height],[width,height]].map(([x,y])=>Math.hypot(x-origin.x,y-origin.y)))*1.09;
    // Real pages vary in length: preserve logo timing and allow a slower long-page journey.
    total=Math.max(Number(config.seconds||8.4)*1000,Math.min(22000,2560+height/650*1000+600));
    const mask=document.createElement('div');
    driver=window.KobColourInk.create({overlay:wave,content:mask,site:document,width,height,origin,reach,durationMs:total,rippleColour:managed?rgbaHex(policy.palette.lilium):undefined});
    const maskImage=mask.style.maskImage;
    records.forEach(rec=>{if(rec.paint){rec.paint.style.maskImage=maskImage;rec.paint.style.webkitMaskImage=maskImage;}});
    running=true;root.dataset.kobColourState='playing';start=performance.now();
    renderFrame=(t,elapsed=t*total)=>{
      if(dirty)measure();
      lastFrame=t;const frame=driver.draw(t);
      drawColours(frame.radius,elapsed);
      if(Math.abs(logoWidth-box.width)>1){
        logo.classList.add('kob-colour-logo-ready');
        const pigment=logo.querySelector('.kob-colour-logo-pigment');pigment.style.maskImage='none';pigment.style.webkitMaskImage='none';
      }
      records.forEach(rec=>{
        if(rec.done||!rec.el.isConnected)return;
        const {x,y,w,h}=rec.rect;
        const far=Math.max(...[[x,y],[x+w,y],[x,y+h],[x+w,y+h]].map(([a,b])=>Math.hypot(a-origin.x,b-origin.y)));
        if(frame.radius*.92>far){settle(rec);return;}
        const paint=rec.paint;if(!paint)return;
        paint.style.maskImage=maskImage;paint.style.webkitMaskImage=maskImage;
        paint.style.maskSize=frame.size+'px '+frame.size+'px';paint.style.webkitMaskSize=paint.style.maskSize;
        paint.style.maskPosition=(origin.x-x-frame.size/2)+'px '+(origin.y-y-frame.size/2)+'px';paint.style.webkitMaskPosition=paint.style.maskPosition;
      });
      if(t>=1&&(elapsed>=total+800||colours.every(rec=>rec.progress===1||!rec.el.isConnected)))finish();
      return {progress:t,radius:frame.radius,origin,height,total};
    };
    let elapsed=0,previous=start;
    function tick(now){
      if(!running)return;
      // A delayed browser frame pauses the journey instead of jumping over visible sections.
      elapsed+=Math.min(50,Math.max(0,now-previous));previous=now;
      try{renderFrame(Math.min(1,elapsed/total),elapsed);}catch{finish();console.warn('KoB colour arrival used its static fallback.');}
      if(running)raf=requestAnimationFrame(tick);
    }
    lastFrame=0;
    if(!inspection)raf=requestAnimationFrame(tick);
    // Tick exceptions settle immediately; no wall-clock watchdog that skips the remaining journey.
  }
  function safeBegin(){try{begin();}catch{finish();console.warn('KoB colour arrival used its static fallback.');}}
  function queue(){
    const image=document.querySelector('.header__heading-logo');
    Promise.race([Promise.all([document.fonts?.ready,image?.decode().catch(()=>{})]),new Promise(resolve=>setTimeout(resolve,1500))]).then(()=>{timeout=setTimeout(safeBegin,450);});
  }
  observer=new ResizeObserver(()=>{dirty=true;});observer.observe(document.body);
  window.addEventListener('resize',()=>{dirty=true;if(running&&width!==document.documentElement.clientWidth)finish();});
  document.addEventListener('visibilitychange',()=>{if(document.hidden&&running)finish();else if(!settled&&!running)safeBegin();});
  window.addEventListener('pagehide',()=>{if(running)finish();});
  window.addEventListener('pageshow',event=>{if(event.persisted&&settled){reset();queue();}});
  document.addEventListener('shopify:section:load',()=>{if(managed&&policy?.stage==='off')return;if(running)finish();discover();});
  reduced.addEventListener('change',()=>{if(reduced.matches){if(running)finish();else if(!settled)safeBegin();}});
  function reset(){
    cancelAnimationFrame(raf);clearTimeout(timeout);driver?.destroy();driver=null;wave?.remove();wave=null;
    clearColours();
    records.forEach(rec=>{rec.paint?.remove();['kobColourSurface','kobColourTone','kobColourPosition','kobColourArrived','kobColourSettled','kobColourMaterial'].forEach(k=>delete rec.el.dataset[k]);});records.clear();
    if(logo){logoSizeObserver.unobserve(logo);logo.querySelector('.kob-colour-logo-pigment')?.remove();logo.classList.remove('kob-colour-logo','kob-colour-logo-ready','kob-colour-dyeing');logo.style.removeProperty('--kob-logo-mask');logo.style.removeProperty('--kob-logo-width');logo.style.removeProperty('--pool');}logo=null;
    delete root.dataset.kobColourActive;delete root.dataset.kobColourState;settled=false;running=false;
  }
  window.KobColourArrival={finish,registerSurfaces(){if(managed&&policy?.stage==='off')return;discover();},replay(){reset();queue();},get state(){return root.dataset.kobColourState||'waiting';}};
  function rgbaHex(hex){return [1,3,5].map(i=>parseInt(hex.slice(i,i+2),16));}
  function changePolicy(next){
    const key=JSON.stringify([next?.stage,next?.revision,next?.palette,next?.seconds,next?.banner_material,next?.logo_monochrome]);
    if(key===policyKey)return;
    policyKey=key;reset();
    paletteStyles.forEach((value,prop)=>restoreStyle(root,prop,value));paletteStyles.clear();
    policy=next;
    if(!next||next.stage==='off'){root.dataset.kobColourState='original';return;}
    config.seconds=next.seconds;
    const variables={};
    Object.entries(next.palette).forEach(([role,value])=>{
      variables['--kob-palette-'+role]=value;
      variables['--kob-palette-'+role+'-rgb']=rgbaHex(value).join(',');
    });
    const blue=rgbaHex(next.palette.lilium);
    const ring=next.logo_monochrome?rgbaHex(next.palette.logo):blue;
    variables['--kob-logo-ring']=next.logo_monochrome?next.palette.logo:next.palette.lilium;
    for(const [shade,offset]of Object.entries({deep:[-41,-31,-20],pale:[12,11,7],mid:[-35,-25,-19],soft:[10,8,1]})){
      variables['--kob-palette-lilium-'+shade]='rgb('+blue.map((v,i)=>Math.max(0,Math.min(255,v+offset[i]))).join(',')+')';
      variables['--kob-logo-ring-'+shade]='rgb('+ring.map((v,i)=>Math.max(0,Math.min(255,v+offset[i]))).join(',')+')';
    }
    // Keep dark-banner text readable without adding more colour controls.
    // The approved warm-grey preset keeps its existing dark text.
    const luminance=hex=>rgbaHex(hex).map(v=>{const s=v/255;return s<=.04045?s/12.92:((s+.055)/1.055)**2.4;}).reduce((v,s,i)=>v+s*[.2126,.7152,.0722][i],0);
    const contrast=(a,b)=>{const x=luminance(a),y=luminance(b);return (Math.max(x,y)+.05)/(Math.min(x,y)+.05);};
    const onDark=contrast(next.palette.ink,next.palette.dark)>=contrast(next.palette.light,next.palette.dark)?next.palette.ink:next.palette.light;
    variables['--kob-palette-dark-ink-rgb']=rgbaHex(onDark).join(',');
    for(const [prop,value]of Object.entries(variables)){paletteStyles.set(prop,saveStyle(root,prop));root.style.setProperty(prop,value);}
    queue();
  }
  if(managed){
    if(preview){
      const previewHost=window.opener||parent;
      window.addEventListener('message',event=>{
        if(event.origin===location.origin&&event.source===previewHost&&event.data?.type==='kob:colour-preview-focus'&&event.data.target==='banner'){
          const banner=document.querySelector('#MainContent .image-with-text__content[data-kob-colour-surface]')||document.querySelector('#MainContent [data-kob-colour-material]')||document.querySelector('#MainContent .image-with-text__content');
          banner?.scrollIntoView({block:'center',behavior:'instant'});return;
        }
        const next=event.data?.policy;
        if(event.origin!==location.origin||event.source!==previewHost||event.data?.type!=='kob:colour-preview'||
          !next||!['off','effect','hold'].includes(next.stage)||!Number.isFinite(next.seconds)||next.seconds<8.4||next.seconds>30||
          (next.banner_material!==undefined&&!['solid','blue-carbon'].includes(next.banner_material))||
          (next.logo_monochrome!==undefined&&typeof next.logo_monochrome!=='boolean')||
          !['light','dark','ink','lilium','accent','logo'].every(k=>/^#[a-f\d]{6}$/i.test(next.palette?.[k]||'')))return;
        changePolicy(next);previewHost.postMessage({type:'kob:colour-preview-shown'},location.origin);
      });
      previewHost.postMessage({type:'kob:colour-preview-ready'},location.origin);
    }else window.addEventListener('kob:colour-policy',event=>changePolicy(event.detail));
    changePolicy(policy);return;
  }
  if(inspection)window.KobColourArrival.advance=t=>{if(!running||t<lastFrame||t>1)throw new Error('Inspection advances monotonically from 0 to 1; reload to restart');return renderFrame(t,t===1?total+800:t*total);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',queue,{once:true});else queue();
})();
